import { isLocalhost } from './api.ts';

/** Playground uses dev client config — same rules as `getClientConfigForEnv`. */
export const isPlaygroundReachable = (env?: string): boolean => {
  if (!env) return true;
  if (env.includes('stage')) return false;
  if (env.includes('dev')) return true;
  return false;
};

/** Sidebar entry is shown only when running the SPA on localhost. */
export const isPlaygroundInSidebar = (): boolean => isLocalhost();
